import type { NotificationKind } from '../types/notifications'

export const NOTIFICATION_DROPDOWN_WIDTH = 360
export const NOTIFICATION_DROPDOWN_MAX_HEIGHT = 480
export const NOTIFICATION_MAX_STORED = 100
export const NOTIFICATION_DEFAULT_KIND: NotificationKind = 'info'
